import { Component } from '@angular/core';
import { CurrencyInput } from '@shared/components/currency-input/currency-input';

@Component({
  selector: 'app-test',
  imports: [CurrencyInput],
  templateUrl: './test.html',
  styleUrl: './test.css',
})
export class Test {}
